<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'UnicoIntegration'
  }
</script>

<style scoped>

</style>